import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";

interface OwnProps {
    isPurchasableOnWeb: boolean;
}

export interface ProductNonPurchasableMessageStyles {
    errorWrapper?: InjectableCss;
    errorText?: TypographyPresentationProps;
}

export const styles: ProductNonPurchasableMessageStyles = {
    errorText: { weight: "bold" },
};

const NonPurchasableMessage = ({ isPurchasableOnWeb }: OwnProps) => {
    if (isPurchasableOnWeb) {
        return null;
    }

    return (
        <StyledWrapper {...styles.errorWrapper}>
            <Typography {...styles.errorText}>{siteMessage("ProductIsNotPurchasableOnWeb")}</Typography>
        </StyledWrapper>
    );
};

export default NonPurchasableMessage;
